import React, { useState } from 'react';
import NotificationsPortal from '../NotificationsPortal';
import CancellationModal from './CancellationModal';
import UndoCancellationLink from './UndoCancellationLink';
import { post, destroy } from './utils';

function useAsyncDebounce(promisedFn) {
    const [available, setAvailable] = useState(true);

    return () => {
        if (available) {
            setAvailable(false);
            promisedFn().finally(() => setAvailable(true));
        };
    };
}

export default function PaymentCancellation({ appData }) {
    const jsonData = JSON.parse(appData);
    const stepId = jsonData.stepId;
    const workerName = jsonData.workerName;
    const [paymentCancellationId, setCancellationId] = useState(jsonData.paymentCancellationId);
    const [cancellationCreatedAt, setCancellationCreatedAt] = useState(jsonData.cancellationCreatedAt)
    const [modalOpen, setModalOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState();
    const [submitDisabled, setSubmitDisabled] = useState(true);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [bannerOpen, setBannerOpen] = useState(false);
    const [bannerContent, setBannerContent] = useState();

    const onClickYes = useAsyncDebounce(() => {
        return destroy(`/payment_cancellations/${paymentCancellationId}`).then(() => {
            setDrawerOpen(false);
            setBannerContent('Your freelancer will be notified to continue work.');
            setBannerOpen(true);
            setCancellationId(null);
            setCancellationCreatedAt(null);
        });
    });

    const onClickNo = () => setDrawerOpen(false);
    const onClickUndo = () => setDrawerOpen(true);

    const onChangeMessage = (e) => {
        setSubmitDisabled(e.target.value.length < 1);
        setModalMessage(e.target.value);
    }
    const onClickSubmit = useAsyncDebounce(() => {
        return post(
            '/payment_cancellations/',
            JSON.stringify({ payment_cancellation: { story_approval_step_id: stepId, message: modalMessage } }),
        ).then(async response => {
            document.body.classList.remove('modal-active');
            setModalOpen(false);
            const { data: { id, attributes: { createdAt } } } = await response.json();
            setCancellationId(parseInt(id, 10));
            setCancellationCreatedAt(createdAt);
            setBannerContent(`⏳ ${workerName} will be notified and will need to confirm the cancellation before you can move forward.`)
            setBannerOpen(true);
        });
    });

    return (
        <div>
            {paymentCancellationId ? (
                <UndoCancellationLink date={cancellationCreatedAt} onClickUndo={onClickUndo} onClickYes={onClickYes} onClickNo={onClickNo} drawerOpen={drawerOpen} />
            ) : (
                <div>
                    <a
                        href="javascript:;"
                        className="button small delete modal-open"
                        data-behavior="tooltip"
                        data-tooltip-text="Cancelling payment will stop work on this step."
                        onClick={() => setModalOpen(true)}
                    >
                        Cancel Payment
                    </a>
                    {modalOpen && <CancellationModal
                        name={workerName}
                        onClickClose={() => {setModalOpen(false)}}
                        onChangeMessage={onChangeMessage}
                        onClickSubmit={onClickSubmit}
                        submitDisabled={submitDisabled}
                    />}
                </div>
            )}
            <NotificationsPortal show={bannerOpen} onClickX={() => setBannerOpen(false)} showX={false}>
                <span>{bannerContent}</span>
            </NotificationsPortal>
        </div>
    )
}



// WEBPACK FOOTER //
// ./app/javascript/client/components/PaymentCancellation/index.jsx